// extracted by mini-css-extract-plugin
module.exports = {"Shim":"AukgJ","Open":"_1p9yP","Modal":"_2Gru3","Content":"_3OvEm","CloseButton":"_1YWTu","Footer":"_2rDQB","Header":"_10QbG","HeaderText":"De-L7"};